import { useContext } from "react";
import { NotiContext } from "~/providers/notification.provider";

export const useNotification = () => {
  const notification = useContext(NotiContext);
  if (!notification) {
    throw new Error(
      "useNotification must be used within a NotificationProvider"
    );
  }
  return notification;
};
